import React, { FC, Fragment, useState } from 'react'
import { Button, DatePicker, Form, Input, InputNumber, Select } from 'antd'
import { ColumnProps } from '@comps/types'
import { Page, Card, Table } from '@comps'
import Modal from '@comps/Modal/Modal'
import { Context, DateUtils, Http, Layout, Message } from '@utils'

const AuthClient: FC = () => {
    let [visible, setVisible] = useState(false)
    const [addForm] = Form.useForm()
    let [table, setTable] = useState<Table>()
    const Item = Form.Item

    const columns: ColumnProps[] = [
        { title: '名称', key: "description", fixed: 'left' },
        { title: '授权方式', key: "supportGrantTypes", width: 200, },
        { title: 'Token有效期(秒)', key: "expiresInSecond", },
        { title: '启用', key: "enabled", width: 90, render: (enabled) => enabled ? '是' : '否' },
        { title: '生效时间', key: "startActiveTime", width: 180 },
        { title: '失效时间', key: "endActiveTime", width: 180 },
        { title: 'Client Id', key: "clientId", width: 300 },
        { title: 'Client Secret', key: "clientSecret", width: 300 },
    ];

    const onTableRef = (tableRef: Table) => {
        table = tableRef
        setTable(tableRef)
    }

    const saveAdd = () => {
        addForm.validateFields().then(values => {
            let supportGrantTypes = addForm.getFieldValue("supportGrantTypes").join(',')
            Http.post('/auth/clients', { ...values, supportGrantTypes: supportGrantTypes }).then((data: any) => {
                addForm.resetFields()
                Message.saveOk()
                setVisible(false)
                Context.route(`/auth/clients`)
                table?.refresh()
            })
        })
    }

    return (
        <Page>
            <Card title='Auth Client' actions={<Fragment>
                <Button type='primary' onClick={() => { setVisible(true) }}>新增</Button>
            </Fragment>}>
                <Table columns={columns} url='/auth/clients' onTableRef={onTableRef}>
                    <Input name='description' placeholder='名称'></Input>
                </Table>
            </Card>

            <Modal visible={visible} title='新增' onCancel={() => setVisible(false)} onOk={() => saveAdd()}>
                <Form {...Layout.modal_1c} name='addForm' form={addForm}
                    initialValues={{ expiresInSecond: 28800, startActiveTime: DateUtils.now() }}
                >
                    <Item name='description' label='名称' rules={[{ required: true }]}>
                        <Input />
                    </Item>
                    <Item name='supportGrantTypes' label='授权模式' rules={[{ required: true }]}>
                        <Select mode='multiple' allowClear options={[
                            { label: 'authorization_code', value: 'authorization_code' },
                            { label: 'password', value: 'password' },
                            { label: 'client_credentials', value: 'client_credentials' },
                            { label: 'APPCODE', value: 'APPCODE' },
                        ]}>
                        </Select>
                    </Item>
                    <Item name='startActiveTime' label='生效时间' rules={[{ required: true }]}>
                        <DatePicker></DatePicker>
                    </Item>
                    <Item name='endActiveTime' label='失效时间'>
                        <DatePicker></DatePicker>
                    </Item>
                    <Item name='expiresInSecond' label='Token有效期' rules={[{ required: true }]}>
                        <InputNumber></InputNumber>
                    </Item>
                </Form>
            </Modal>
        </Page >
    )
}

export { AuthClient }